import React from 'react'
import { Avatar, AvatarProps } from 'antd'

type AppIconProps = AvatarProps & {
    name: string
    toolkit: string
    logo?: string | null
}

export function AppIcon({ name, toolkit, logo, ...props }: AppIconProps) {
    return (
        <Avatar
            shape="square"
            src={logo ?? `https://logos.composio.dev/api/${encodeURIComponent(toolkit)}`}
            alt={name}
            className="border border-gray-200 bg-white text-gray-700 [&_img]:object-contain"
            {...props}
        >
            {name.trim().charAt(0).toUpperCase()}
        </Avatar>
    )
}
